import { useLayoutEffect, useRef, useState } from "react";
export function useHeight() {
    const ref = useRef(null);
    const [height, setHeight] = useState(0);
    useLayoutEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setHeight(entry.contentRect.height);
            }
        });
        observer.observe(element);
        setHeight(ref.current.offsetHeight);
        return () => observer.disconnect();
    }, []);
    return { ref, height };
}
//# sourceMappingURL=useHeight.js.map